var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1548 18.9959H0.0083682L0 7.74733C0 7.55696 0.167364 7.41625 0.330544 7.35417C1.61506 7.43694 2.72803 7.5611 4.00837 7.76389V6.84927L2.13808 6.79133L3.20502 4.38684L2.53138 4.35374C2.46025 4.35374 2.30544 4.30821 2.25523 4.27097C2.19247 4.22544 2.23431 4.02679 2.27197 3.95644C3.05021 2.64038 3.71967 1.37399 4.6318 0L6.99582 3.95644C7.02929 4.01438 7.06276 4.20061 7.02929 4.242C6.98326 4.2958 6.86193 4.33718 6.76569 4.3496L6.14644 4.40754L7.12552 6.79133L5.10042 6.84927L5.11297 8.02875C8.41423 8.87301 11.4268 10.3339 14.0502 12.4818C16.1799 14.249 17.9331 16.3265 19.1548 18.9959Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9833 18.2137C17.5733 13.8931 14.3097 10.9464 9.63184 8.71162C12.7281 6.99413 16.0837 6.0464 19.5774 5.90983C19.8159 5.90155 20.0042 6.09607 20.0042 6.31955L19.9833 18.2178V18.2137Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.cd79bd9913908953bbaa85aa5b1f814e.svg";
export { ForwardRef as ReactComponent };